import React from 'react';
import ReactModal from 'react-modal';
import { Carousel } from 'react-responsive-carousel';
import { AiOutlineClose } from 'react-icons/ai';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import { IEspaco } from '../../types/Espaco';
import { IFotEsp } from '../../types/FotEsp';

interface IEspacoDetalhesModalProps {
  isOpen: boolean;
  onClose: () => void;
  espaco?: IEspaco;
  fotos: IFotEsp[];
}

export default function EspacoDetalhesModal({ isOpen, onClose, espaco, fotos }: IEspacoDetalhesModalProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      appElement={document.getElementById('root') as HTMLElement}
      contentLabel={`Detalhes do espaço ${espaco?.esp || ''}`}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      overlayClassName='fixed inset-0 z-[99] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in'
      className='relative flex w-full max-h-[92dvh] flex-col overflow-hidden rounded-t-2xl bg-white shadow-card outline-none animate-slide-up md:max-w-2xl md:rounded-2xl'
    >
      <div className='flex items-center justify-between border-b border-zinc-100 px-5 py-4'>
        <h2 className='text-lg font-semibold text-zinc-900'>{espaco?.esp}</h2>
        <button
          type='button'
          onClick={onClose}
          aria-label='Fechar'
          className='flex h-10 w-10 items-center justify-center rounded-full text-zinc-500 hover:bg-zinc-100 hover:text-zinc-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900'
        >
          <AiOutlineClose className='h-5 w-5' aria-hidden='true' />
        </button>
      </div>

      <div className='overflow-y-auto px-5 py-4'>
        {fotos.length > 0 ? (
          <Carousel
            showArrows={true}
            showStatus={false}
            showThumbs={false}
            swipeable={true}
            emulateTouch={false}
            infiniteLoop={false}
            showIndicators={fotos.length > 1}
            autoPlay={false}
            className='overflow-hidden rounded-xl bg-zinc-100'
          >
            {fotos.map((fotEsp) => (
              <div key={fotEsp.cod}>
                <img
                  src={fotEsp.linfot}
                  alt={espaco?.esp}
                  className='w-full max-h-[55vh] object-contain'
                />
              </div>
            ))}
          </Carousel>
        ) : (
          <div className='flex aspect-video w-full items-center justify-center rounded-xl bg-zinc-100 text-sm text-zinc-400'>
            Nenhuma foto cadastrada
          </div>
        )}

        {espaco?.det && (
          <div
            className='mt-4 text-sm leading-relaxed text-zinc-700'
            dangerouslySetInnerHTML={{ __html: espaco.det }}
          />
        )}
      </div>
    </ReactModal>
  );
}
